module.exports = "<div class=badge-container> <span class=\"badge {{ tag.key }}\" ng-repeat=\"tag in product.tags\"> {{ tag.value }} </span> </div>";